import { API_VERSION } from "../common/config";

export const PAGE_URL = {
    MAIN: "",
    // Login
    LOGIN: "/login",
    FINDPWD: "/findpwd",

    FIRSTLOGIN: "/firstlogin",

    RESETPWD: "resetpwd",
    CHANGEPWD: "changepassword",
    CHANGEPWDERR: "changepwderr",
    CHANGEPWDSUC: "changepwdsuc",

    NICE: "/nice",
    AUTH_SUCCESS: "/authsuccess",
    AUTH_FAIL: "/authfail",

    EMAIL_AUTH: "/emailauth",


    // Define the navigation menu
    DASHBOARD: "/dashboard",

    INFRA_RESOURCE_MANAGER_DASHBOARD: "/rack_dashboard",
    INFRA_RESOURCE_MANAGER_RACKIMAGE: "/rack_image",

    VIRTUAL_RESOURCE_GROUP_REGION: "/region",
    VIRTUAL_RESOURCE_GROUP_HOST_CLUSTER: "/host_cluster",
    VIRTUAL_RESOURCE_GROUP_AZ: "/az",

    VIRTUAL_PHYSICAL_RESOURCE_HOST: "/host",
    VIRTUAL_PHYSICAL_RESOURCE_STORAGE: "/storage",
    VIRTUAL_PHYSICAL_RESOURCE_NETWORK: "/network",

    APPLICATION_MY_INFO: "/myinfo",
    APPLICATION_ACCOUNT: "/account",
    APPLICATION_PASSWORD: "/password",
    APPLICATION_DOMAIN: "/domain",
    APPLICATION_PROJECT: "/project",
    APPLICATION_SMTP: "/smtp",

    VIRTUAL_LOGICAL_RESOURCE_IMAGE: "/image",
    VIRTUAL_LOGICAL_RESOURCE_PERFORMANCE: "/performance",
    VIRTUAL_LOGICAL_RESOURCE_NETWORK: "/logical_network",
    VIRTUAL_LOGICAL_RESOURCE_ROUTER: "/router",
    VIRTUAL_LOGICAL_RESOURCE_NETWORK_TOPOLOGY: "/logical_network_topology",
    VIRTUAL_LOGICAL_RESOURCE_SECURITY: "/security",
    VIRTUAL_LOGICAL_RESOURCE_SECURITY_RULE: "/security_rule",
    VIRTUAL_LOGICAL_RESOURCE_IP: "/floatingip",
    VIRTUAL_LOGICAL_RESOURCE_KEY_PAIR: "/keypair",

    VIRTUAL_INSTANCE_MGMT_VM: "/vm",
    VIRTUAL_INSTANCE_MGMT_VM_BACKUP_IMAGE: "/backup",
    VIRTUAL_INSTANCE_MGMT_VOLUMNE: "/volume",

    CONTAINER_LOGICAL_RESOURCE_NODE: "/node",
    CONTAINER_LOGICAL_RESOURCE_CLUSTER: "/cluster",
    CONTAINER_LOGICAL_RESOURCE_NAMESPACE: "/namespace",
    CONTAINER_LOGICAL_RESOURCE_CLUSTER_TEMPLATE: "/container_cluster_template",
    CONTAINER_LOGICAL_RESOURCE_REGISTRY: "/registry",

    CONTAINER_CLUSTER_MGMT_NAMESPACE: "/container_namespace",
    CONTAINER_CLUSTER_MGMT_IMAGE: "/container_image",
    CONTAINER_CLUSTER_MGMT_POD_PROFILE: "/pod_profile",
    CONTAINER_CLUSTER_MGMT_APPLICATION_POD: "/pod",
    CONTAINER_CLUSTER_MGMT_APPLICATION_DEPLOYMENT: "/deployment",
    CONTAINER_CLUSTER_MGMT_POD_VOLUME: "/pvc",
    CONTAINER_CLUSTER_MGMT_SERVICE: "/service",
    CONTAINER_CLUSTER_MGMT_INGRESS: "/ingress",

    VIRTUAL_INSTANCE_USEAGE_VM: "/use_vm",
    VIRTUAL_INSTANCE_USEAGE_VM_DISK: "/use_disk",
    VIRTUAL_INSTANCE_USEAGE_VM_VOLUME: "/use_volume",


    LOG_MGMT: "/log",
    LOG_AUDIT: "/audit",

    SETTING_DEFAULT: "/default",

    DETAIL_MANAGEMENT: "detail",
    RESTORE_MANAGEMENT: 'restore',

    SERVICE_PRODUCT: "/product",
    SERVICE_LICENSE: "/license",
    SERVICE_PURCHASE: "/purchase",
    SERVICE_RDS_CLIENT_PACKAGE: "/rdsclientpakcage",
    SERVICE_RDS_DEVICE: "/rdsdevice",

    ERRORPAGE: "/error"
};



export const PLATFORM_URL = {
    BASE: "/api/" + API_VERSION,

    LOGIN: "/sessions/login",
    LOGOUT: "/sessions/logout",
    REFRESH: "/sessions/refreshtoken",
    FIND_PSSWORD: '/sessions/sendtemporarypassword',


    /* 응용 관리 */
    USERS: '/users',
    PROJECT: '/projects',
    HOST: '/hosts',
    PWD_CHANGE: '/changepassword',
    SMTP: '/system/smtp',


    /* 가상화 자원 그룹 관리 */
    AZ: '/availabilityzones',
    HOST_CLUSTER: '/hostclusters',
    ADD_HOST_: '/addhost',
    REMOVE_HOST: '/removehost',
    REGION: '/regions',


    /* 가상화 플랫폼 물리 자원 관리 */
    STORAGE_POOL: '/storagepools',


    /* 가상화 플랫폼 논리 자원 관리 */
    VM_IMAGE: '/vmimages',


    /* 가상화 플랫폼 가상 인스턴스 관리 */
    VM: '/vms',
    VOLUME: "/volumes",
    VM_BACKUP: '/vmbackups',
    VOLUME_SNAPSHOT: "/volumesnapshots",


    /* 가상화 플랫폼 논리 리소스 관리 */
    CONTAINER_CLUSETER_TEMPLATE: "/containerclustertemplates",
    CONTAINER_CLUSETER: "/containerclusters",


    /* 컨테이너 플랫폼 클러스터 관리 */
    POD_NAMESPACE: "/namespaces",
    POD_IMAGE: "/containerimages",
    POD_PROFILE: "/podprofiles",
    POD_DEPLOYMENT: "/deployments",
    POD: "/pods",
    POD_PVC: "/persistentvolumeclaims",
    POD_SERVICE: "/services",


    /* 로그 관리 */
    AUDIT_LOG: '/system/logs/audits',
    SYSTEM_LOG: '/system/logs/systems',



    /* 기타 */
    SYNC: '/sync',
    SUBNET: '/subnets',







    // VM: "/service/vm",
    VM_NETWORK: "/networks",
    NETWORK_PORT: "/networkports",






    DASHBOARD: "/dashboard",

    // LOGIN: "/service/user/login",


    ACCOUNT: "/serivces/users",

    USER_COMPANY: "/service/usercompany",
    MY_PROFILE: "/myprofile",
    PWD_CHNAGE: "/service/user/changepwd",

    // AZ: "/platform/az",
    // REGION: "/platform/region",
    // HOST: "/platform/host",
    // STORAGE_POOL: "/platform/storagepool",

    DOMAIN: "/platform/domain",

    // HOST_CLUSTER: "/platform/hostcluster",
    INSTANCE_TYPE: "/vmtypes",
    KEY_PAIR: "/vmkeypairs",

    // VM: "/service/vm",
    // VM_IMAGE: "/service/vmimage",
    // VM_NETWORK: "/service/network",

    // VOLUME: "/service/volume",
    // VOLUME_SNAPSHOT: "/service/volumesnapshot",

    SECURITY_GROUP: "/securitygroups",
    FLOATING_IP: "/floatingips",


    NODE: "/nodes",
    REGISTRY: "/registries",

    // POD: "/service/pod",
    // POD_DEPLOYMENT: "/service/deployment",
    // POD_IMAGE: "/service/containerimage",
    // POD_NAMESPACE: "/service/namespace",
    // POD_PROFILE: "/service/podprofile",
    // POD_PV: "/service/pv",
    // POD_PVC: "/service/pvc",
    // POD_SERVICE: "/service/service",
    INGRESS: "/ingresses",

    ROUTER: "/routers",
    // AUDIT_LOG: "/platform/audit",

    /* Data Center Map */
    DATA_CENTER_TOPOLOGY: "/centers/topology",

    PRODUCT: "/products",
    LICENSE: "/licenses",
    PURCHASE: "/purchases",
    CLIENT_PACKAGE: "/clients",
    RDS_DEVICE: "/rdsclients/devices",
    VDI_SESSION: "/vdisessions/session",
};
